import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { notify } from "../../../utils/shared";
const API_URL = process.env.REACT_APP_API_URL;
const GET_ALL_PLANS = `${API_URL}/coachPlans/getAllCoachPlans`;
const PLAN_URL = `${API_URL}/coachPlans`;
const GET_ALL_MEMBER_PLANS = `${API_URL}/playerPlans/getAllPlayerPlans`;
const MEMBER_PLAN_URL = `${API_URL}/playerPlans`;
const GET_ALL_AGENT_PLANS = `${API_URL}/agentPlans/getAllAgentPlans`;
const AGENT_PLAN_URL = `${API_URL}/agentPlans`;

export const getPlans = createAsyncThunk(
  "getPlans",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { page, limit, search = '' } = values
      const { data } = await axios.get(`${GET_ALL_PLANS}?page=${page}&limit=${limit}&search=${search}&all=true`, {});
      return data;
    } catch (error: any) {
      const { responseMessage } = error?.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const updatePlanDetails = createAsyncThunk(
  "updatePlanDetails",
  async ({values, id, page}: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.put(`${PLAN_URL}/${id}`, values);
      notify(data.responseMessage, 'success');
      dispatch(getPlans({page: page || 1, limit:10, all: true}));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const addPlanDetails = createAsyncThunk(
  "addPlanDetails",
  async ({values,page}: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.post(`${PLAN_URL}`, values);
      notify(data.responseMessage, 'success');
      dispatch(getPlans({ page: page || 1, limit: 10, all: true }))
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const deletePlan = createAsyncThunk(
  "deletePlan",
  async (values: any, { rejectWithValue, dispatch }) => { 
    try {
      const { data } = await axios.delete(`${PLAN_URL}/${values.id}`);
      notify(data.responseMessage, 'success'); 
      dispatch(getPlans({page: values.selectedPage || 1, limit:10,all: true}));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const getMemberPlans = createAsyncThunk(
  "getMemberPlans",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { page, limit, search = '' } = values
      const { data } = await axios.get(`${GET_ALL_MEMBER_PLANS}?page=${page}&limit=${limit}&search=${search}&all=true`, {});
      return data;
    } catch (error: any) {
      const { responseMessage } = error?.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const updateMemberPlanDetails = createAsyncThunk(
  "updateMemberPlanDetails",
  async ({values, id, page}: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.put(`${MEMBER_PLAN_URL}/${id}`, values);
      notify(data.responseMessage, 'success');
      dispatch(getMemberPlans({page: page || 1, limit:10, all: true}));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const addMemberPlanDetails = createAsyncThunk(
  "addMemberPlanDetails",
  async ({values,page}: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.post(`${MEMBER_PLAN_URL}`, values);
      notify(data.responseMessage, 'success');
      dispatch(getMemberPlans({ page: page || 1, limit: 10, all:true }))
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const deleteMemberPlan = createAsyncThunk(
  "deleteMemberPlan",
  async (values: any, { rejectWithValue, dispatch }) => { 
    try {
      const { data } = await axios.delete(`${MEMBER_PLAN_URL}/${values.id}`);
      notify(data.responseMessage, 'success'); 
      dispatch(getMemberPlans({page: values.selectedPage || 1, limit:10, all: true}));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const getAgentPlans = createAsyncThunk(
  "getAgentPlans",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { page, limit, search = '' } = values
      const { data } = await axios.get(`${GET_ALL_AGENT_PLANS}?page=${page}&limit=${limit}&search=${search}&all=true`, {});
      return data;
    } catch (error: any) {
      const { responseMessage } = error?.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const updateAgentPlanDetails = createAsyncThunk(
  "updateAgentPlanDetails",
  async ({values, id, page}: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.put(`${AGENT_PLAN_URL}/${id}`, values);
      notify(data.responseMessage, 'success');
      dispatch(getAgentPlans({page: page || 1, limit:10, all: true}));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const addAgentPlanDetails = createAsyncThunk(
  "addAgentPlanDetails",
  async ({values, page}: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.post(`${AGENT_PLAN_URL}`, values);
      notify(data.responseMessage, 'success');
      dispatch(getAgentPlans({ page: page || 1, limit: 10, all: true }));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const deleteAgentPlan = createAsyncThunk(
  "deleteAgentPlan",
  async (values: any, { rejectWithValue, dispatch }) => { 
    try {
      const { data } = await axios.delete(`${AGENT_PLAN_URL}/${values.id}`);
      notify(data.responseMessage, 'success'); 
      dispatch(getAgentPlans({page: values.selectedPage || 1, limit:10, all: true}));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);